// src/services/dataService.js

import { QUIZ_LISTS } from '../config/quizLists';

export const fetchQuizData = async (listId) => {
    const quizList = QUIZ_LISTS.find(q => String(q.id) === String(listId));
    if (!quizList) throw new Error('Lista quizów nie istnieje!');
    const response = await fetch(`/data/${quizList.file}`);
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    return await response.json();
};
